import { Link } from "@components/index";
import { LINKS } from "@components/Link/Link";
import TypographyV2 from "@components/TypographyV2/TypographyV2";
import React from "react";
import * as styles from "./ColumnsTemplate.module.scss";
import { NavbarTopic } from "./Products";

export const links: NavbarTopic[] = [
	{
		id: 1,
		title: "About",
		to: "ABOUT_US",
		icon: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M4 13H19.587C20.0495 13 20.2808 13 20.4128 12.903C20.528 12.8185 20.6015 12.6887 20.6147 12.5464C20.63 12.3833 20.511 12.185 20.273 11.7884L18.247 8.4116C18.1572 8.26195 18.1123 8.18712 18.0947 8.10724C18.0792 8.03659 18.0792 7.96341 18.0947 7.89276C18.1123 7.81288 18.1572 7.73805 18.247 7.5884L20.273 4.2116C20.511 3.81503 20.63 3.61674 20.6147 3.45359C20.6015 3.31133 20.528 3.18154 20.4128 3.09698C20.2808 3 20.0495 3 19.587 3H4L4 21"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		),
	},
	{
		id: 2,
		title: "Careers",
		to: "CAREER",
		icon: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_261_15660)">
					<path
						d="M19 7H5C3.89543 7 3 7.89543 3 9V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7Z"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M8 7V5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H14C14.5304 3 15.0391 3.21071 15.4142 3.58579C15.7893 3.96086 16 4.46957 16 5V7"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M12 12V12.01"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M3 13C5.79158 14.4067 8.87403 15.1394 12 15.1394C15.126 15.1394 18.2084 14.4067 21 13"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</g>
				<defs>
					<clipPath id="clip0_261_15660">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
	},
	{
		id: 3,
		to: "EVENTS",
		title: "Events",
		icon: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_261_2689)">
					<path
						d="M18 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V7C20 5.89543 19.1046 5 18 5Z"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M16 3V7"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M8 3V7"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M4 11H20"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M10 15H8V17H10V15Z"
						stroke="#2C52F7"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</g>
				<defs>
					<clipPath id="clip0_261_2689">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
	},
];

const Company = () => {
	return (
		<div>
			{links.map(({ title, icon, to }, index) => {
				return (
					<Link key={index} to={LINKS[to || "LANDING"].to}>
						<div className={styles.row}>
							{icon}
							<TypographyV2 weight="MEDIUM">{title}</TypographyV2>
						</div>
					</Link>
				);
			})}
		</div>
	);
};

export default Company;
